// Construct the WhatsApp link
export function buildWhatsAppMessageLink(
  userData: { fName: any; lName: any; email: any; mobile?: string },
  flightData: { categoryName: any },
  quoteNumber: string
) {
  const number = "+966920003455";
  const message = `Hi! My name is ${userData.fName} ${userData.lName}. \n My email is ${userData.email}. I have already sent you a mail for quotation of ${flightData.categoryName} with reference No. ${quoteNumber}. Awaiting for your response. Thanks`;
  const whatsappLink = `https://api.whatsapp.com/send?phone=${encodeURIComponent(
    number
  )}&text=${encodeURIComponent(message)}`;

  // Open the WhatsApp link in a new tab/window
  window.open(whatsappLink, "_blank");
}
